{
  "greeting": "Bonjour ! Comment puis-je vous aider avec le vin aujourd'hui ?",
  "thinking": "✨ Réflexion...",
  "thinkingStep": "✨ Débouchage de l'accord parfait pour vous…🍷",
  "askAboutWine": "Ex. Bordeaux rouge des années 90 environ $1500 | Bourgogne blanc village moins de $600",
  "askAboutWineFirst": "Je veux acheter (région + couleur + millésime + budget)",
  "waitingForResponse": "En attente de réponse...",
  "dailyLimitReached": "Vous avez atteint la limite quotidienne de conseils. Veuillez revenir après 00h00 HKT pour continuer.",
  "chatHistory": "Votre historique de chat",
  "noChatHistory": "Pas encore d'historique de chat",
  "startConversation": "Commencez une conversation pour la voir ici",
  "backToChat": "Retour au chat",
  "newChat": "Nouveau chat",
  "history": "Historique",
  "search": "Rechercher",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Conseiller en vins",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} vin recommandé",
  "winesRecommended": "{count} vins recommandés",
  "justNow": "À l'instant",
  "minuteAgo": "Il y a {count} minute",
  "minutesAgo": "Il y a {count} minutes",
  "hourAgo": "Il y a {count} heure",
  "hoursAgo": "Il y a {count} heures",
  "dayAgo": "Il y a {count} jour",
  "daysAgo": "Il y a {count} jours",
  "noMessagesYet": "Pas encore de messages",
  "perBottle": "Par bouteille",
  "priceNA": "Prix non disponible",
  "buyNow": "Acheter maintenant",
  "moreInformation": "Plus d'informations",
  "share": {
    "button": "Partager",
    "title": "Partager la conversation",
    "description": "Partagez cette conversation avec vos amis en utilisant le lien ci-dessous :",
    "generating": "Génération du lien de partage...",
    "error": "Échec de la génération du lien de partage",
    "copy": "Copier",
    "copied": "Copié !",
    "note": "Remarque : Ce lien expirera dans 30 jours. Lorsque quelqu'un ouvrira ce lien, il verra une copie de cette conversation."
  },
  "checkOutWine": "Découvrez ce vin : {name} {vintage}",
  "linkCopied": "Lien copié dans le presse-papiers !",
  "contactWhatsApp": "Contactez-nous sur WhatsApp pour plus d'options",
  "errorLoadingWine": "Désolé, je n'ai pas pu charger les détails du vin.",
  "errorOccurred": "Une erreur est survenue lors de la récupération de la réponse.",
  "you": "Vous",
  "welcome": {
    "intro": "Bienvenue chez WWX, je suis Zyra, votre conseillère en vins IA. Vous pouvez accéder à :",
    "features": {
      "globalMarket": "Marché mondial des grands vins (vendeurs UK, FR, HK)",
      "realTimeOffers": "Meilleures offres en temps réel dans votre budget",
      "personalized": "Recommandations personnalisées rien que pour vous",
      "comparison": "Comparaison facile des millésimes et des marques",
      "instantCheckout": "Quantités et expédition instantanées"
    },
    "question": "Que puis-je vous recommander aujourd'hui ?",
    "trendingPrompts": "Exemples de requêtes",
    "promptExamples": {
      "title": "Comment demander :",
      "good": "✓ Bons exemples :",
      "bad": "✗ Évitez les requêtes sans budget :"
    },
    "prompts": {
      "bordeaux": "Bordeaux rouge environ $800",
      "champagne": "Champagne de vigneron moins de $2000",
      "firstGrowth": "Meilleure offre premier cru 2010-2019"
    }
  },
  "feedback": {
    "helpful": "C'était utile",
    "notHelpful": "Ce n'était pas utile",
    "thankYou": "Merci pour votre retour !",
    "whatDidYouLike": "Qu'avez-vous aimé ?",
    "whatCouldBeImproved": "Qu'est-ce qui pourrait être amélioré ?",
    "category": "Catégorie",
    "selectCategory": "Sélectionnez une catégorie",
    "categories": {
      "accuracy": "Précision",
      "helpfulness": "Utilité",
      "responseSpeed": "Vitesse de réponse",
      "clarity": "Clarté",
      "other": "Autre"
    },
    "comments": "Commentaires",
    "placeholder": "Dites-nous en plus sur votre expérience...",
    "cancel": "Annuler",
    "submit": "Envoyer l'avis",
    "submitting": "Envoi en cours..."
  },
  "auth": {
    "limitReached": "Limite quotidienne atteinte",
    "signUpToday": "Inscrivez-vous pour plus de messages",
    "limitMessage": "Vous avez atteint votre limite quotidienne de messages. Inscrivez-vous gratuitement pour continuer à discuter.",
    "benefitsMessage": "Créez un compte gratuit pour continuer à discuter et sauvegarder votre historique de chat sur tous vos appareils.",
    "remainingMessages": "Il vous reste {count} messages aujourd'hui",
    "signUp": "S'inscrire",
    "login": "Se connecter",
    "loggedInAs": "Connecté en tant que {email}",
    "logout": "Se déconnecter"
  }
}
